import React, { useState } from 'react';
import CommonTable from 'components/CommonTable';
import styled from 'styled-components';
import { Nav, Row, Col, Tab, Spinner } from 'react-bootstrap';
import { CustomButton } from 'components/CustomForm';
import { HiDocumentText } from 'react-icons/hi';
import { FaUsers } from 'react-icons/fa';
import { HDivider } from 'components/CommonWidgets';
import CompaniesManagementTab from './companies-management-tab';
import UsersManagementTab from './users-management-tab';
import UserGroupsTab from './user-groups-management-tab';

const Holder = styled.div`
  width: 100%;

  div.loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3876e5;
    min-height: 30rem;
  }

  div.empty {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 10rem;
	text-align: center;
	color: #616161;
	font-size: 14pt;
  }
`;

const MainCard = styled.div`
	background-color: white;
	position: relative;
	border-radius: 26px;
	margin: -2rem 4.5rem 0 4.5rem;
	padding: 0 3rem 0 3rem;
`;

const TabsCard = styled.div`
	background-color: white;
	margin: 0 auto;
	border-radius: 26px;
`;

const TabColumn = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
        color: black;
        font-weight: 900;
        font-size: 14pt;
    }
`;

const TabLine = styled.div`
	width: 10em;
	height: 0.5rem;
	background-color: #0278ee;
	border-top-left-radius: 11px;
	border-top-right-radius: 11px;
`;

const TabContent = styled(Tab.Content)`
    width: 100%;
    margin: 2rem 0 3rem 0;
	padding: 0 4rem 0 4rem;
    transition: all 500ms ease-in-out;
`;

const UsersTab = () => {
	const [ currentTab, setCurrentTab ] = useState('users-management');

	return (
		<Holder>
			<MainCard>
			<Tab.Container defaultActiveKey={currentTab} onSelect={(k) => setCurrentTab(k)}>
				<TabsCard className="pt-4">
					<Nav>
						<Row className="w-100">
						<TabColumn md={4}>
								<HiDocumentText size={26} />
								<Nav.Item>
									<Nav.Link className='text-center' eventKey={'groups-management'}>گروه های کاربری</Nav.Link>
								</Nav.Item>
								{currentTab === 'groups-management' && <TabLine />}
							</TabColumn>
							<TabColumn md={4}>
								<HiDocumentText size={26} />
								<Nav.Item>
									<Nav.Link className='text-center' eventKey={'companies-management'}>شرکت های تعاونی</Nav.Link>
								</Nav.Item>
								{currentTab === 'companies-management' && <TabLine />}
							</TabColumn>
							<TabColumn md={4}>
								<FaUsers size={26} />
								<Nav.Item>
									<Nav.Link className='text-center' eventKey={'users-management'}>مدیریت کاربران</Nav.Link>
								</Nav.Item>
								{currentTab === 'users-management' && <TabLine />}
							</TabColumn>
						</Row>
						<HDivider />
					</Nav>
				</TabsCard>
				<Row>
					<TabContent>
						<Tab.Pane eventKey="users-management">
							<UsersManagementTab currentTab={currentTab} />
						</Tab.Pane>
						<Tab.Pane eventKey="companies-management">
							<CompaniesManagementTab currentTab={currentTab} />
						</Tab.Pane>
						<Tab.Pane eventKey="groups-management">
							<UserGroupsTab currentTab={currentTab} />
						</Tab.Pane>
					</TabContent>
				</Row>
			</Tab.Container>
		</MainCard>
		</Holder>
	);
};

export default UsersTab;
